import React,{useState,useContext} from 'react';
import Modal from '../Settings/Modal';
import { SettingModal, useSettingModal } from '../../../hooks/Context';
import styled from '@emotion/styled';
import { TopDisplay,Button,UploadButton } from '../../../ui-components';
import apiCall from '../../../utils/apiCall';
import fileDownload from 'js-file-download';
import { NotificationContext } from '../../../providers/notification';
import DispalyUpload from './DispalyUpload';
import apiCallFormData from '../../../utils/apiFormDataCall';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ExNyRoute,PrRoute, ExRoute, AcRoute, MiRoute,  CoRoute } from '../../../utils/allRouteId';

const option1:any= [
  {val:ExNyRoute, name:"Examination / NYSC",path:``},
  {val:PrRoute, name:"Practitioner",path:`practitioner`},
  {val:ExRoute, name:"Executive",path:`executive`},
  {val:AcRoute, name:"Academic",path:`academic`},
  {val:MiRoute, name:"Military",path:`military`},
  {val:CoRoute, name:"Corporate",path:`corporate`}
]
export default function TrainingInvites() {

  const [route, setRoute] = useState<{name: string, val: number}>({name: 'Examination / NYSC', val: Number(ExNyRoute)})

  return (

      <SettingModal>
        <ViewWrapper>
                <TopDisplay subTitle={`All Training/ Induction OffLine Payment Upload Page` }title="Training/Induction Upload" Btn={<TopBtns id={route?.val}/>} />
                <DispalyUpload route= {route} setRoute = {setRoute}/>
        </ViewWrapper>
        {/* <Modal /> */}
      </SettingModal>
  )
}

const TopBtns = ({ id }: { id: number }) => {
  const { showNotification } = useContext(NotificationContext);
  const [uLoading, setULoading] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const routeId = id || 1;

  // Download Template (from /public)
  const handleDownloadTemplate = () => {
    setDownloading(true);
    const link = document.createElement("a");
    link.href = "/training-induction-template.xlsx"; // file placed in /public
    link.setAttribute("download", "training-induction.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => setDownloading(false), 1000);
  };

  // Reusable upload function

  const uploadPayment = async (data: FormData, endpoint: string) => {
  return await apiCallFormData().post(endpoint, data, {
    responseType: "blob", // allow receiving files too
  });
};

const handleUpload = async (
  e: React.ChangeEvent<HTMLInputElement>,
  activity: "Training" | "Induction"
) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const body = new FormData();
  body.append("ExcelFile", file);

  setULoading(true);
  try {
    const endpoint =
      activity === "Training"
        ? "/Applicant/UploadOfflineApplicantTraining"
        : "/Applicant/UploadOfflineApplicantInduction";

    await uploadPayment(body, endpoint);

    showNotification({
      message: `${activity} file uploaded successfully`,
      type: "success",
    });
  } catch (error: any) {
    // Check if backend returned a file (e.g., error report)
    const blob = error?.response?.data;

    if (blob instanceof Blob) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${activity}_UploadErrorReport.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      showNotification({
        message: `Upload failed — error report downloaded`,
        type: "error",
      });
    } else {
      showNotification({
        message:
          error?.response?.data?.Message || error?.message || "File not uploaded",
        type: "error",
      });
    }
  } finally {
    setULoading(false);
    e.target.value = ""; // reset file input
  }
};


  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <UploadButton
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleUpload(e, "Training")}
        label={!uLoading ? "Upload Training Payment" : "Uploading..."}
      />
      <UploadButton
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleUpload(e, "Induction")}
        label={!uLoading ? "Upload Induction Payment" : "Uploading..."}
      />
      <Button
        onClick={handleDownloadTemplate}
        border="#E2E4E9"
        bg="#11643C"
        color="#fff"
      >
        {downloading ? "Downloading..." : "Download Template"}
      </Button>
    </div>
  );
};


const ViewWrapper = styled.div`
  width: 100%;
  padding:0 48px 48px;
`
